import React from 'react'
import {
  DatePicker,
  TextField
} from 'material-ui'
import moment from 'moment-timezone'
import { offsetToContentTimezone, contentTimezone, contentTimezoneOffset } from '../../dates'
import chrono from 'chrono-node'

const styles = {
  container: {
    width: '100%'
  },
  date: {
    width: '50%',
    display: 'inline-block'
  },
  time: {
    width: '50%',
    display: 'inline-block'
  }
}

function parseDate (chronoTime) {
  if (chronoTime) {
    return moment(offsetToContentTimezone(chronoTime)).format('hh:mm A')
  }
  return ''
}

class DateTimePicker extends React.Component<any, any> {
  constructor (props) {
    super(props)
    this.state = {
      date: props.value ? offsetToContentTimezone(this.props.value) : null,
      time: props.value ? parseDate(props.value) : '',
      hasTimeBeenBlured: false,
      hasDateBeenBlured: false
    }
  }

  componentWillReceiveProps (nextProps) {
    if (!this.state.hasTimeBeenBlured) {
      this.setState({
        time: nextProps.value ? parseDate(nextProps.value) : ''
      })
    } else {
      this.setState({
        time: parseDate(chrono.parseDate(this.state.time))
      })
    }
    if (!this.state.hasDateBeenBlured) {
      this.setState({
        date: nextProps.value ? offsetToContentTimezone(nextProps.value) : null
      })
    } else if (this.state.date) {
      this.setState({
        date: offsetToContentTimezone(this.state.date)
      })
    }
  }

  handleDateChange = (e, date) => {
    this.setState({
      date: date
    })
    let newDate
    if (this.props.value) {
      newDate = moment(this.props.value).tz(contentTimezone)
    } else {
      newDate = moment().tz(contentTimezone)
    }
    newDate.year(date.getFullYear())
    newDate.month(date.getMonth())
    newDate.date(date.getDate())
    this.props.onChange(null, newDate.toDate())
  }

  handleDateBlur = (e) => {
    this.setState({
      hasDateBeenBlured: true
    })
  }

  handleTimeBlur = (e) => {
    this.setState({
      hasTimeBeenBlured: true
    })
    const chronoTime = chrono.parseDate(e.target.value)
    if (chronoTime) {
      const newDate = moment(this.props.value || undefined).tz(contentTimezone)
      newDate.hour(chronoTime.getHours())
      newDate.minute(chronoTime.getMinutes())
      newDate.seconds(0)
      newDate.milliseconds(0)
      this.props.onChange(null, newDate.toDate())
    } else {
      const newDate = moment(this.props.value || undefined).tz(contentTimezone)
      this.props.onChange(null, newDate.toDate())
    }
  }

  handleTimeChange = (e) => {
    this.setState({
      time: e.target.value
    })
  }

  render () {
    return (
      <div style={styles.container}>
        <div style={styles.date}>
          <DatePicker
            firstDayOfWeek={0}
            value={this.state.date}
            floatingLabelText={`${this.props.name} Day`}
            onChange={this.handleDateChange}
            onBlur={this.handleDateBlur}
            errorText={this.props.errorText || null}
            autoOk
            disabled={this.props.disabled || false}
          />
        </div>
        <div style={styles.time}>
          <TextField
            value={this.state.time}
            floatingLabelText={`Time (GMT ${contentTimezoneOffset})`}
            onBlur={this.handleTimeBlur}
            onChange={this.handleTimeChange}
            errorText={this.props.errorText || null}
            disabled={this.props.disabled || false}
          />
        </div>
      </div>
    )
  }
}

export default DateTimePicker
